import { Card, Col, Tabs, TabsProps } from "antd";
import React from "react";
import UserBasicDetails from "./UserBasicDetails";
import VoucherSecurity from "./VoucherSecurity";
import MasterSecurity from "./MasterSecurity";
import ReportSecurity from "./ReportSecurity";
import { useLocation, useNavigate } from "react-router-dom";
import SettingSecurity from "./SettingSecurity";
import { ArrowLeftOutlined } from "@ant-design/icons";

export const reportType = [
  "Balance Sheet",
  "PnL",
  "Trial Balance",
  "Cash Flow",
  "Debtors Ageing",
  "Creditors Ageing",
  "Customer Outstanding",
  "Supplier Outstanding",
  "General Ledger",
  "FAR",
  "BRS",
  "GST",
  "TCSTDS",
];

export const masterType = [
  "Client",
  "Ledger",
  "Group",
  "Item",
  "Item Group",
  "Unit",
  "Asset",
  "Requisition",
];

export const settingType = [
  "Company Info",
  "Voucher",
  "Report",
  "Opening Entry",
  "Templates",
  "Default Ledger",
  "TnC",
  "Email",
];

const UsersDetailsTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  let userId = location?.state?.userId;

  console.log("userId", userId);

  const onChange = (key: string) => {
    console.log(key);
  };
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Basic Details",
      children: (
        <>
          <UserBasicDetails userId={userId} />
        </>
      ),
    },
    {
      key: "2",
      label: "Voucher Security",
      children: (
        <>
          <VoucherSecurity userId={userId} />
        </>
      ),
    },
    {
      key: "3",
      label: "Report Security",
      children: (
        <>
          <ReportSecurity userId={userId} />
        </>
      ),
    },
    {
      key: "4",
      label: "Master Security",
      children: (
        <>
          <MasterSecurity userId={userId} />
        </>
      ),
    },
    {
      key: "5",
      label: "Setting Security",
      children: (
        <>
          <SettingSecurity userId={userId} />
        </>
      ),
    },
  ];
  return (
    <>
      <div>
        {/* <Card
          size="small"
          className="TableCard"
          style={{
            width: "100%",
            height: "100%",
            // minHeight: "60vh",
            // marginLeft: "16px",
            boxShadow: "0px 0px 10px 0px #96A1C84D",
            // marginTop: "30px",
            marginTop: "15px",
            border: "1px solid #eef2fe",
          }}

            size="small"
          className="TableCard"
          style={{
            justifyContent: "center",
            margin: "15px 15px 0px 15px",
            boxShadow: "0px 0px 10px 0px #96A1C84D",
            height: "90vh",
          }}
        ></Card> */}

        <Card
          size="small"
          className="TableCard"
          style={{
            // margin: "10px",
            borderRadius: "1px solid #eef2fe",
            margin: "15px 15px 0px 15px",
            boxShadow: "0px 0px 10px 0px #96A1C84D",
            height: "90vh",
          }}
        >
          <>
            <Col lg={1} style={{ marginLeft: "15px" }}>
              <ArrowLeftOutlined onClick={() => navigate(-1)} />
            </Col>
            <Tabs
              className="ca-tab-addItem"
              defaultActiveKey="1"
              items={items}
              onChange={onChange}
            />
          </>
        </Card>
      </div>
    </>
  );
};

export default UsersDetailsTabs;
